'use client'

import { type PropsWithChildren, type ReactNode, createContext, useContext } from 'react'

const MarkdownDescriptionContext = createContext<ReactNode>(null)

type MarkdownDescriptionProviderProps = PropsWithChildren<{
  /** Server-rendered `MarkdownDescriptionContent`, or `null` when the room has no visible Markdown. */
  content: ReactNode
}>

/** Hands the server-rendered Markdown description down to the client world info components. */
export function MarkdownDescriptionProvider({
  content,
  children,
}: MarkdownDescriptionProviderProps) {
  return (
    <MarkdownDescriptionContext.Provider value={content}>
      {children}
    </MarkdownDescriptionContext.Provider>
  )
}

export const useMarkdownDescription = () => useContext(MarkdownDescriptionContext)
